export const CharacterCompassIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path
        d="M11.0001 20.84C16.4787 20.84 20.9201 16.3987 20.9201 10.92C20.9201 5.44134 16.4787 1 11.0001 1C5.52141 1 1.08008 5.44134 1.08008 10.92C1.08008 16.3987 5.52141 20.84 11.0001 20.84Z"
        stroke="#010101"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.08008 10.92H20.9201" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.5502 3.78998L3.99023 17.35" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.5293 1.39001V20.72" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.2207 4.48999L17.5507 17.82" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
